// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wq77","content":"styles_content__1tZ4e","row":"styles_row__2BfqP","footer":"styles_footer__2eqUq","phraseLength":"styles_phraseLength__FqlOu"};